import MY_JSON from '../assets/json/data.json';
export const dataJSON=MY_JSON;
